var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"flex-shrink-1"},[_c('v-row',{staticClass:"flex-shrink-1 justify-center"},_vm._l((_vm.challenges),function(challenge){return _c('Challenge',{key:challenge.title,attrs:{"challenge":challenge}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }